import axios from 'axios';

const getCotacoes = params => axios.get('/cotacoes', {
  params,
});

const getCotacoesProdutos = params => axios.get('/cotacoes/produtos/page', {
  params,
});

export default {
  getCotacoes,
  getCotacoesProdutos,
};
